export type DraftAttachment =
  | { kind: "existing-file"; signedId: string; fileName: string; downloadUrl: string }
  | { kind: "new-file"; file: File }
  | { kind: "link"; url: string; name: string }

export const MAX_NOTE_ATTACHMENTS = 20
export const ALLOWED_NOTE_ATTACHMENT_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "text/csv",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "image/png",
  "image/jpeg",
  "image/gif",
]

const MAX_FILE_SIZE = 20 * 1024 * 1024

type AddNoteAttachmentFilesResult = { ok: true; attachments: DraftAttachment[] } | { ok: false; error: string }

export function addNoteAttachmentFiles(attachments: DraftAttachment[], files: File[]): AddNoteAttachmentFilesResult {
  const remainingSlots = MAX_NOTE_ATTACHMENTS - attachments.length
  if (files.length > remainingSlots) {
    return {
      ok: false,
      error: `You can only add ${remainingSlots} more file(s). Maximum is ${MAX_NOTE_ATTACHMENTS}.`,
    }
  }

  for (const file of files) {
    if (file.size > MAX_FILE_SIZE) {
      return { ok: false, error: `${file.name} is too large. Maximum size is 20MB.` }
    }
    if (!ALLOWED_NOTE_ATTACHMENT_TYPES.includes(file.type)) {
      return { ok: false, error: `${file.name} has an unsupported file type.` }
    }
  }

  return {
    ok: true,
    attachments: [...attachments, ...files.map((file): DraftAttachment => ({ kind: "new-file", file }))],
  }
}
